import Vial from './Vial';

export default Vial;